import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { ListCompanies } from 'src/_shared/navigation/aside/listCompaniesGraphQL.js';

/**
 * All companies (super-admin cross-tenant list, the same query the aside company switcher uses),
 * paginated to exhaustion and name-sorted. `companies` is null while loading; a load failure sets
 * `failed` and resolves to [] so callers can fall back to a plain id input and stay usable.
 * (The Job comparison console uses this same pattern inline; extracted here for the promote dialog.)
 */
export function useAllCompanies() {
	const client = useApolloClient();
	const [companies, setCompanies] = useState(null);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				let all = [];
				let nextToken = null;
				do {
					const { data } = await client.query({
						query: ListCompanies,
						variables: { limit: 1000, nextToken },
						fetchPolicy: 'network-only',
					});
					all = all.concat(data?.listCompanies?.items || []);
					nextToken = data?.listCompanies?.nextToken;
				} while (nextToken && !cancelled);
				if (!cancelled) setCompanies(all.sort((a, b) => (a.name || '').localeCompare(b.name || '')));
			} catch {
				if (!cancelled) {
					setFailed(true);
					setCompanies([]);
				}
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [client]);

	return { companies, failed, loading: companies === null };
}
